import * as api from '../api';

export const ListCustomers = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/customer/list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const CustomerDetails = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/customer/details/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerSettings = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/customer/settings/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const CustomerOnlineProfile = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/customer/online-profile/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const CustomerOnlineProfileUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/customer/online-profile', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerSettingsUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/customer/settings/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerPluginSettingsUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/customer/plugin_settings/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerFileUpload = (data, file_type, history) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", data);
        formData.append("file_type", file_type);

        api
            .post('/customer/uploadfile', formData,
                {
                    headers: { "Content-Type": "multipart/form-data", },
                }
            )
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);

                reject(error);
            })
    });
};

export const CustomerAdd = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/customer/add', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SearchCustomers = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/customer/search', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/customer/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerDelete = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/customer/delete', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerDeleteFile = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/customer/deletefile', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const AddCustomerDiscountProduct = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post(`/customer/customer_discount_product`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ExportCustomers = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/customer/export', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ListCustomerPayments = (id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/customer/payments/${id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};